import { render, staticRenderFns } from "./CalculatorPersonalGainQuickstartBonusItem.vue?vue&type=template&id=979e0ae8&scoped=true"
import script from "./CalculatorPersonalGainQuickstartBonusItem.vue?vue&type=script&lang=js"
export * from "./CalculatorPersonalGainQuickstartBonusItem.vue?vue&type=script&lang=js"
import style0 from "./CalculatorPersonalGainQuickstartBonusItem.vue?vue&type=style&index=0&id=979e0ae8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979e0ae8",
  null
  
)

export default component.exports